import SearchAutoSuggestComponent from '../../components/autocomplete/SearchAutoSuggest';
import { palette } from '../../theme/palette';
import { SearchIcon } from '../../components/location-modal/LocationModalStyle';
import { styled } from '@mui/material';

export const SearchAutoSuggest = styled(SearchAutoSuggestComponent)`
  height: 40px;
  width: 100%;
  border-radius: 5px;
  border: 1pt solid #a9a9a9;
  overflow: hidden;
  transition: border-color 0.3s ease;

  &:focus-within {
    border-color: ${palette.primary.main};
  }

  @media (max-width: 991px) {
    border: 1px solid #fd6600;
  }
`;

export const StyleSearchAutoSuggestIcon = styled(SearchIcon)`
  color: ${palette.primary.main};
  width: 17px;
  cursor: pointer;
`;


export const SEARCH_AUTOSUGGEST_GLOBAL_STYLE_ID = 'es-search-autosuggest-styles';

export const searchAutoSuggestGlobalCss = `
  #esp-links-menu-container { position: relative; overflow: visible; }

  #es-search-autosuggest > .MuiBox-root { width: 100%; height: 100%; }
  #es-search-autosuggest .autocomplete-field-container,
  #es-search-autosuggest #autocomplete-input { min-width: 0; }
  #es-search-autosuggest #autocomplete-input { padding: 0; box-sizing: border-box; }

  @media (min-width: 1280px) {
    #esp-links-menu-container { padding-left: 142px; }
    #es-search-autosuggest.desktop {
      position: absolute; left: 0; right: auto; top: 0; bottom: 0; height: 40px; margin: auto 0;
      width: 132px; z-index: 5; transition: width .3s ease .2s, z-index 0s .2s;
    }
    #es-search-autosuggest.desktop:focus-within { width: 100%; z-index: 100; transition: width .3s ease, z-index 0s; }
  }

  @media (min-width: 991px) and (max-width: 1279px) {
    #es-search-autosuggest.desktop {
      position: absolute; left: var(--es-search-toggle-left, 0); right: auto;
      top: 0; bottom: 0; height: 40px; margin: auto 0;
      width: 0; max-width: 190px; overflow: hidden; z-index: 5; transition: width .3s ease .2s, z-index 0s .2s;
    }
    #es-search-autosuggest.desktop:focus-within {
      width: var(--es-search-expand-width, 100%); z-index: 100; overflow: visible; transition: width .3s ease, z-index 0s;
    }
  }

  @media (max-width: 991px) {
    #es-search-autosuggest.desktop { display: none; }
  }
`;
